export default __webpack_public_path__ + "static/Bolton-63e22a62019e6578298e5ea106554160.jpg";